import { esc } from '@/utils/escape';
import { resolveNavHref } from '@/generators/html/content-pages/nav-helper';

export function generateHeaderHTML(data: any, settings: any): string {
  const navItems = (data.navItems || [])
    .map(
      (item: any) =>
        `        <a href="${resolveNavHref(item, settings, false)}" class="header__nav-link">${esc(item)}</a>`,
    )
    .join("\n");

  return `  <!-- Header -->
  <header class="header" id="header">
    <div class="container">
      <div class="header__inner">
        <a href="index.html" class="header__brand">
          ${
            data.logoUrl
              ? `<img src="${esc(data.logoUrl)}" alt="${esc(data.companyName)}" class="header__logo">`
              : `<div class="header__logo">${esc(data.logoText)}</div>`
          }
          <span class="header__name">${esc(data.companyName)}</span>
        </a>

        <nav class="header__nav" id="main-nav">
${navItems}
          ${settings.darkModeToggle ? '<button class="header__dark-toggle" id="dark-toggle" aria-label="Dark Mode umschalten"></button>' : ""}
          <a href="#kontakt" class="header__cta btn btn--primary">${esc(data.ctaText)}</a>
        </nav>

        <button class="header__toggle" id="menu-toggle" aria-label="Menü öffnen" aria-expanded="false">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <!-- Mobile Navigation -->
    <nav class="header__mobile-nav" id="mobile-nav" aria-hidden="true">
${navItems.replace(/header__nav-link/g, "header__mobile-link")}
      <a href="#kontakt" class="btn btn--primary">${esc(data.ctaText)}</a>
    </nav>
  </header>`;
}
